import { FC } from 'react';
import { Box, Center, Flex } from 'styled-system/jsx';
import LeftArrow from '@/common/assets/icons/arrowLeftIcon.svg?react';
import { useNavigate } from 'react-router-dom';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { BackwardHandlerType } from '@/common/types/LayoutTypes';

type Props = { title: string } & BackwardHandlerType;

const TitleHeader: FC<Props> = ({ title, backwardHandler }) => {
  const navigate = useNavigate();
  const handleBackTrigger = () => {
    backwardHandler ? backwardHandler() : navigate(-1);
  };
  return (
    <Flex
      maxW="maxContainer"
      mx="auto"
      bgColor="white"
      shadow="headerShadow"
      height="66px"
      alignItems="center"
    >
      <Center onClick={handleBackTrigger} w="15%">
        <LeftArrow />
      </Center>
      <Box w={'80%'}>
        <Typography textAlign="center" color="black-1">
          {title}
        </Typography>
      </Box>
      <Box w={'15%'} />
    </Flex>
  );
};

export default TitleHeader;
